// extracted by mini-css-extract-plugin
export var fullWidthButton = "_p1-0";